import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as AdminSessionActions from "../../state/redux/adminSession";
import { deepCopyObject } from "../../utils/helpers";
import ReportDialog from "../dialogs/reportDialog";
import SurveyReports from "../ui/surveyReports";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

// import * as ReportSessionActions from "../../state/redux/reportSession";

const AdminReports = props => {
  const { reportODMs, loadReportsRequest, reportPageLoading, reportPagination } = props;

  useEffect(() => {
    if (reportODMs != null) {
      setRows(reportODMs);
    }
  }, [reportODMs]);

  const [selectedReport, setSelectedReport] = useState(null);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (reportPagination != null) {
      setTitleText(`${reportPagination.totalItems} Generated`);
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportPagination]);

  return (
    <Widget>
      <WidgetTitle title={"Reports"} text={titleText}></WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyReports
            reportODMs={rows}
            onEditReport={setSelectedReport}
            onRequestNewPage={loadReportsRequest}
            isLoading={reportPageLoading}
            reportPagination={reportPagination}
          />
        </WidgetSurveyContent>
      )}

      {selectedReport && (
        <ReportDialog
          open={selectedReport != null}
          dialogTitle={`${selectedReport._id == null ? "Create" : "Edit"} Report`}
          omniODM={deepCopyObject(selectedReport)} //this widget just creates new
          onDelete={patient_id => {
            props.deleteReportRequest(patient_id);
            setSelectedReport(null);
          }}
          onAccept={report => {
            if (report._id == null) {
              props.createReportRequest(report);
            }
            setSelectedReport(null);
          }}
          onClose={() => {
            setSelectedReport(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  reportODMs: state.adminSession.reportODMs,
  reportPageLoading: state.adminSession.reportPageLoading,
  reportPagination: state.adminSession.reportPagination,
});

const mapDispatchToProps = {
  loadReportsRequest: AdminSessionActions.loadReportsRequest,

  deleteReportRequest: AdminSessionActions.deleteReportRequest,
  setReportODMRequest: AdminSessionActions.setReportODMRequest,
  createReportRequest: AdminSessionActions.createReportRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminReports));
